__turbopack_context__.v({
  "loading": "FolderSharingModalList-module__Mr127a__loading",
  "root": "FolderSharingModalList-module__Mr127a__root",
});
